import { render, staticRenderFns } from "./FavouriteEmailIcon.vue?vue&type=template&id=08c04416&scoped=true&"
import script from "./FavouriteEmailIcon.vue?vue&type=script&lang=js&"
export * from "./FavouriteEmailIcon.vue?vue&type=script&lang=js&"
import style0 from "./FavouriteEmailIcon.vue?vue&type=style&index=0&id=08c04416&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08c04416",
  null
  
)

export default component.exports